import styled, { css } from 'styled-components';
import { Tooltip } from '@mui/material';
import { Colors } from '../../../../../../../constants';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0 24px;
    `}
`;

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  white-space: normal;
  align-items: center;
`;

export const IconContainer = styled.div`
  color: var(--light-blue);
  font-size: 20px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CancelIconContainer = styled.div`
  color: var(--light-blue);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlaceIconContainer = styled.div`
  color: var(--luft-primary);

  & > svg {
    position: relative;
    top: -14px;
  }

  &:after {
    content: ".";
    width: 8px;
    height: 8px;
    background-color: var(--luft-primary);
    position: absolute;
    border-radius: 50%;
    text-indent: -9999px;
    z-index: 0;
    top: 24px;
    left: 50%;
    margin-left: -4px;
    margin-top: -4px;
  }
`;

export const StatusName = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: var(--light-blue);
  line-height: 14px;
  margin-bottom: 2px;
  ${({activeStatus}) => activeStatus && 'color: var(--luft-primary);'}
  ${({notStarted}) => notStarted && `color: ${Colors.GREY_150};`}
`;

export const StatusNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const TransferBadge = styled.span`
  display: flex;
  width: 21px;
  height: 20px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${Colors.SECONDARY_LIGHT_BLUE};
  border: 1px solid ${Colors.SECONDARY_LIGHT_BLUE};
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;

  ${({completed}) => completed && `color: ${Colors.SECONDARY_LIGHT_DARK}; border-color: ${Colors.SECONDARY_LIGHT_DARK};`}
  ${({activeStatus}) => activeStatus && 'color: var(--luft-primary); border-color: var(--luft-primary);'}
  ${({notStarted}) => notStarted && `color: ${Colors.GREY_150}; border-color: ${Colors.GREY_150};`}
`;

export const TransferTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.30) 100%), ${Colors.SECONDARY_LIGHT_BLUE};
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    padding: 4px 8px;
    border-radius: 4px;
  }

  & .MuiTooltip-arrow {
    color: #4D9AD0;
  }
`;

export const SubtitleText = styled.span`
  color: var(--light-opacity-gray);
  font-size: 10px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.4px;

  ${({ uppercase }) =>
    uppercase &&
    `
    text-transform: uppercase;
  `}
`;

export const IconContent = styled.div`
`;

export const ConnectionLine = css`
  position: absolute;
  background-color: var(--light-blue);
  margin-top: -2px;
  width: calc(50% - 18px);
  flex: 1;
  height: 2px;

  ${({ grayLine }) =>
    grayLine &&
    `
    background-color: ${Colors.GREY_150};
  `}
`;

export const LeftConnectionLine = styled.div`
  ${ConnectionLine};
  right: -1px;
  bottom: auto;
`;

export const RightConnectionLine = styled.div`
  ${ConnectionLine};
  left: -1px;
  top: auto;
`;
